import { render, staticRenderFns } from "./OldBaseUploadImage.vue?vue&type=template&id=310fe7b3&scoped=true&"
import script from "./OldBaseUploadImage.vue?vue&type=script&lang=js&"
export * from "./OldBaseUploadImage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./OldBaseUploadImage.vue?vue&type=style&index=1&id=310fe7b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fe7b3",
  null
  
)

export default component.exports